<template>
  <div class="container">
    <div class="row justify-content-center">
      <h3>Overzicht shiften {{ selectedTimesheetInfo.username }}</h3>
    </div>
    <div v-if="currentlySelectedUser.onProlongedSickLeave">Deze gebruiker staat momenteel op
      langdurige ziekte.<br> Er kunnen geen shifts of afwezigheden toegevoegd worden.</div>
    <div class="row justify-content-between pb-3">
      <div class="col-md-4 col-sm-12 justify-content-center">
        <AdminMonthSelectComponent/>
      </div>
      <template>
        <div class="row">
          <div v-if="showShiftButton">
            <div v-if="showCreateShift">
              <button class="btn-basic btn-fill-pulse-dark" style="height: 60px;"
                  @click="toggleCreateShift()">Annuleren</button>
            </div>
            <div v-else>
              <button
                  class="btn-basic btn-fill-pulse mr-2" @click="toggleCreateShift()"
                  style="height: 60px;"
                  :disabled="currentlySelectedUser.onProlongedSickLeave">Shift toevoegen</button>
            </div>
          </div>
          <div v-if="showAbsenceButton">
            <div v-if="showCreateAbsence">
              <button class="btn-basic btn-fill-pulse-dark" style="height: 60px;"
                  @click="toggleCreateAbsence()">Annuleren</button>
            </div>
            <div v-else>
              <button
                  class="btn-basic btn-fill-pulse" @click="toggleCreateAbsence()"
                  style="height: 60px;"
                  :disabled="currentlySelectedUser.onProlongedSickLeave">Afwezigheid toevoegen</button>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="row" v-if="showCreateShift">
      <AdminCreateWorkedShift id="createShift" @shiftAdded="toggleCreateShift"/>
    </div>
    <div class="row" v-if="showCreateAbsence">
      <AdminCreateAbsence id="createAbsence" @absenceAdded="toggleCreateAbsence"/>
    </div>
    <div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="customerName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Klant"/>
            <SortableTableHeaderComponent
                columnName="title" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Shift type"/>
            <SortableTableHeaderComponent
                columnName="date" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Datum"/>
            <SortableTableHeaderComponent
                columnName="hours" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Gewerkte uren"/>
          </tr>
          </thead>
          <template v-for="row in sortedRows">
            <AdminTableRow :rowObject="row" :key="row.date + row.title"/>
          </template>
        </table>
      </div>
      <div>
        <button
            v-if="isDownloading" class="btn-basic btn-dark"
            disabled>
          Downloading
        </button>
        <button
            v-else class="btn-basic btn-dark"
            @click="downloadPdf(selectedTimesheetInfo.contractId)">Download PDF
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import AdminTableRow from "../components/WorkedShiftDetailTab/AdminTableRow";
import {mapActions, mapGetters} from "vuex";
import AdminCreateWorkedShift from "../components/EditDetailsComponent/AdminCreateWorkedShift";
import AdminCreateAbsence from "@/components/EditDetailsComponent/AdminCreateAbsence";
import * as moment from "moment";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import AdminMonthSelectComponent from "@/components/MonthSelectComponent/AdminMonthSelectComponent";

export default {
  name: "AdminEditDetails",
  components: {
    SortableTableHeaderComponent,
    AdminTableRow,
    AdminMonthSelectComponent,
    AdminCreateWorkedShift,
    AdminCreateAbsence,
  },
  data: () => ({
    showCreateShift: false,
    showCreateAbsence: false,
    showShiftButton: true,
    showAbsenceButton: true,
    isDownloading: false,
    currentSortColumn: "date",
    currentSortDirectionAscending: true,
  }),
  computed: {
    ...mapGetters({
      workShifts: "administrationTimeSheet/workedShifts",
      absenceDays: "timesheet/absenceDays",
      selectedUser: "user/currentLoggedInUser",
      currentlySelectedUser: "administrationUser/selectedUserDetail",
      selectedTimesheetInfo: "administrationTimeSheet/selectedTimeSheetInfo",
      completed: 'administrationTimeSheet/completed',
      activeContracts: 'administrationTimeSheet/activeContracts',
      contractId: 'administrationTimeSheet/currentlySelectedContractId',
      currentlySelectedContractId: 'administrationTimeSheet/currentlySelectedContractId'
    }),
    //TODO: fetch userId of owner of timesheet depending on selected contract. for now the logged in user is being shown
    ownerOfShifts: function () {
      if (this.workShifts?.length > 0) {
        return this.selectedUser;
      }
      return null;
    },
    sortedRows: function () {
      const workShifts = this.getWorkedShiftsWithIdInDay();
      const absenceDays = this.getAbsenceDays();
      const rows = [...workShifts, ...absenceDays];

      if (this.currentSortColumn === "date") {
        return sortListByColumnAndDirection(rows, this.currentSortColumn, this.currentSortDirectionAscending, this.dateToMillis);
      }
      return sortListByColumnAndDirection(rows, this.currentSortColumn, this.currentSortDirectionAscending);
    },
  },
  created() {
    this.fetchWorkedCustomerTimesheetWithContractInfo();
    this.getAllActiveContractsAndPickSelected();
    this.fetchDetailsForSelectedUserByUserId(this.selectedTimesheetInfo.userId);
  },
  methods: {
    ...mapActions("timesheet", ['downloadTimeSheet']),
    ...mapActions("administrationUser", ['fetchDetailsForSelectedUserByUserId']),
    ...mapActions("administrationTimeSheet", ['addAbsence']),
    ...mapActions("administrationTimeSheet", [
      'fetchWorkedCustomerTimesheetWithContractInfo',
      'getAllActiveContractsAndPickSelected',
      'downloadAdminTimeSheet'
    ]),
    getWorkedShiftsWithIdInDay() {
      const workedShifts = this.workShifts.map(workShift => ({
        type: 'workShift',
        customerName: workShift.customerName,
        title: workShift.title,
        date: moment(workShift.labourPeriod?.startDateTimestamp),
        hours: workShift.workedHours,
        color: workShift.color,
        textColor: workShift.textColor,
        shift: workShift,
        editedByAdmin: workShift.editedByAdmin
      }));

      const ascending = true;
      const workShiftsSortedByDate = sortListByColumnAndDirection(workedShifts, "date", ascending, this.dateToMillis);

      workShiftsSortedByDate.forEach(shiftRow => {
        shiftRow.idInDayForCustomer = this.getIdInDayForCustomer(shiftRow, workShiftsSortedByDate);
      });
      return workShiftsSortedByDate;
    },
    getAbsenceDays() {
      return this.absenceDays.map(absence => ({
        type: 'absence',
        customerName: '',
        title: absence.title,
        date: moment(absence.start),
        hours: absence.hours,
        color: absence.color,
        textColor: absence.textColor,
        shift: absence,
        editedByAdmin: absence.editedByAdmin
      }));
    },
    getIdInDayForCustomer(rowObject, orderedShiftsByDate) {
      const currentDay = rowObject.date;

      const shiftsInSameDayAndSameCustomer = orderedShiftsByDate
          .filter(row => this.isSameDay(row.date, currentDay))
          .filter(row => row.shift.customerName === rowObject.shift.customerName);
      return shiftsInSameDayAndSameCustomer.indexOf(rowObject);
    },
    toggleCreateShift() {
      this.showCreateShift = !this.showCreateShift;
      this.showAbsenceButton = !this.showAbsenceButton;
    },
    toggleCreateAbsence() {
      this.showCreateAbsence = !this.showCreateAbsence;
      this.showShiftButton = !this.showShiftButton;
    },
    downloadPdf(id) {
      this.isDownloading = true;
      this.downloadAdminTimeSheet(id)
          .then(() => this.isDownloading = false)
          .catch(() => this.isDownloading = false);
    },
    isSameDay(date1, date2) {
      return date1.isSame(date2, 'day');
    },
    dateToMillis(date) {
      return moment(date).valueOf();
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  }
};
</script>
